import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE } from "../config/site";
import { scrollToId } from "../lib/scroll";
import { track } from "../lib/analytics";
import { useBookingUrl } from "../context/ContentContext";

export const FinalInvitation = () => {
  const bookingUrl = useBookingUrl();
  return (
  <section
    data-testid="final-invitation-section"
    className="relative overflow-hidden bg-forest-deep py-28 text-center sm:py-36"
  >
    <img
      src={SITE.images.finalBg}
      alt=""
      aria-hidden="true"
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover opacity-40"
    />
    <div
      aria-hidden="true"
      className="absolute inset-0 bg-gradient-to-b from-forest-deep/90 via-forest-deep/70 to-forest-deep/95"
    />
    <div className="relative mx-auto max-w-3xl px-5 sm:px-8">
      <Reveal>
        <h2 className="font-serif text-3xl leading-snug text-ivory sm:text-4xl lg:text-5xl">
          Your way back to yourself begins with{" "}
          <em className="italic text-gold-soft">a single deep breath</em>
        </h2>
        <p className="mx-auto mt-7 max-w-xl text-lg font-light leading-relaxed text-ivory/75">
          Book a consultation when you're ready, or simply join the letter and grow alongside
          us for a while first. Both are welcome here.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-11 flex flex-wrap items-center justify-center gap-5">
          <a
            href={bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-book-session-button"
            onClick={() => track("booking_click", { location: "final-invitation" })}
            className="group inline-flex items-center gap-2 rounded-full bg-gold px-8 py-4 text-sm font-semibold text-forest-deep transition-all duration-300 hover:bg-gold-soft hover:-translate-y-0.5 hover:shadow-[0_16px_40px_rgba(180,146,83,0.35)]"
          >
            Book a Session
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
          <button
            data-testid="final-join-newsletter-button"
            onClick={() => scrollToId("#newsletter")}
            className="inline-flex items-center rounded-full border border-ivory/30 bg-forest-deep/40 px-8 py-4 text-sm font-semibold text-ivory backdrop-blur-sm transition-all duration-300 hover:border-gold-soft hover:text-gold-soft"
          >
            Join the Newsletter
          </button>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
